module.exports = __webpack_public_path__ + "static/elderly-ed4859626ffefedee484f782f3c9e4ec.jpg";